// v1.1 lead-gen source badge (Jorwin 2026-07-21: "make this data visible").
// Renders ONLY for chatbot-sourced leads — manual/CSV leads show nothing, so
// tenants without a chatbot see no change anywhere (DoR-33, data-driven).
// Label reads "Source", never "Channel" (Channel = business category here).
const SHORT = { facebook: 'FB', instagram: 'IG', tiktok: 'TikTok' };
const FULL = { facebook: 'Facebook', instagram: 'Instagram', tiktok: 'TikTok' };

export default function SourceBadge({ lead }) {
  if (lead?.source !== 'inbound-messenger') return null;
  const p = lead.sourcePlatform ?? 'facebook';
  return (
    <span
      className="badge"
      title={`Lead source: ${FULL[p] ?? 'Facebook'} chatbot (inbound)`}
      style={{ background: '#E7F0FB', color: '#2A6DB5', marginLeft: 6 }}
    >
      {SHORT[p] ?? 'FB'}
    </span>
  );
}
